<script lang="ts" setup>
defineProps<{
  icon: string
  title: string
}>()
</script>

<template>
  <a
    class="absolute -right-2 -top-2 rounded-full border-[1.5px] border-white bg-[#F6F6F6] p-0.5 !no-underline"
    href="#"
    :title="title"
  >
    <SvgIcon class="!size-4" :name="icon" />
  </a>
</template>
